import type { CharacterEquipmentType } from './types/game';

/** The loadout's three groups of equipment slots. */
export type EquipmentGroup = 'weapons' | 'armor' | 'miscellaneous';

/** The off hand's index among the weapon slots; the main hand is 0. */
export const OFF_HAND_INDEX = 1;

/**
 * Whether an item of `equipmentType` can be worn in slot `index` of
 * `group`: weapons in either hand, a shield in the off hand only, armor on
 * the body, rings and amulets in the accessory slots. An item with no
 * equipment type is never worn. The client's drop targets, the run host and
 * the item store all decide a move on this.
 */
export function canEquipInSlot(equipmentType: CharacterEquipmentType | null | undefined, group: EquipmentGroup, index: number): boolean {
    switch (group) {
        case 'weapons':
            return equipmentType === 'melee' || equipmentType === 'range' || (equipmentType === 'shield' && index === OFF_HAND_INDEX);
        case 'armor':
            return equipmentType === 'armor';
        case 'miscellaneous':
            return equipmentType === 'ring' || equipmentType === 'amulet';
    }
}
